var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWebsiteLogo = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 42,
  height: 42,
  viewBox: "0 0 42 42",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 21,
  cy: 21,
  r: 21,
  fill: "#01147C"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M18 38V13.1072H24.6786V38H18Z",
  fill: "#FCFCFC"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.3618 6.73524H22.1782L23.5463 4.47678C23.6778 4.25093 23.52 4 23.2569 4H21.0206C20.9154 4 20.8101 4.05018 20.7312 4.15058L18.0477 8.69264C17.9161 8.89341 18.074 9.16942 18.3108 9.16942H20.6523L20.0735 11.5282C19.9946 11.8294 20.4155 12.0301 20.626 11.7792L24.5988 7.26225C24.7829 7.06148 24.6251 6.73528 24.362 6.73528L24.3618 6.73524Z",
  fill: "#FF9E0D"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgWebsiteLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Website_Logo.af6906d260cfc5d11f92b0a15d9c3e25.svg";